import {
  Challenge,
  // ExpertiseLevel,
  GenerateScriptParams,
} from 'src/api/generatedContent';

export function postChallengeToScriptParams(
  challenge: Challenge
): GenerateScriptParams {
  return {
    topic: challenge.title,
    coachingGoal: challenge.challenge,
    keyPoints: [`Response: ${challenge.response}`],
  };
}

export const formatDate = (dateString: string): string => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
};
